import React from "react";

const HabitacionesSection = (props) => {
  const { habitaciones = [] } = props;


  return (
    <div className="card hotel">
      <div className="card-header" id="headingTwo">
        <h5>
          <button
            className="btn btn-link"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
          >
            Habitaciones
            <i className="material-icons">keyboard_arrow_up</i>
          </button>
        </h5>
      </div>
      <div
        id="collapseTwo"
        className="collapse accordion-info show"
        aria-labelledby="headingTwo"
        data-parent="#accordion"
      >
        <div className="card-body">
          {habitaciones.map((hab, i) => <h4 key={i}>{(i + 1)} - Habitacion de tipo {hab.nombreTipo}</h4>)}
        </div>
      </div>
    </div>
  );
};

export default HabitacionesSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/habitacionesSection.js